/* eslint-disable no-unused-vars */
import React from 'react'

import { useAuth } from '../context/AuthContext/AuthContext'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

const ProtectedRoute = ({ path, element, ...props }) => {
  const { user } = useAuth()
  return user ? (
    <>
      {element}
      <Outlet />
    </>
  ) : (
    <Navigate to={'login'} replace />
  )
}

export default ProtectedRoute
